//default from angular libraries
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

//import constants
import { AppSettings } from '../../../constants/app-settings';
import { AppFrontRoutes } from '../../../constants/app-front-routes';

//import service
import { AuthService } from '../../../services/auth.service';
import { UserLayoutService } from '../../../services/UserLayout.service';

@Component({
  selector: '[app-user-header]',
  templateUrl: './user-header.component.html',
  styleUrls: ['./user-header.component.css']
})
export class UserHeaderComponent implements OnInit {

  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;
  language;
  lang;
  userName: string;
  lastLogin: string;
  profileImage: SafeUrl;
  apiResponse:any
  constructor(
    private authService: AuthService,
    private router: Router,
    private userLayoutService: UserLayoutService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {

    this.userLayoutService.data.subscribe(resp => {

      if(resp)
      {
        let result = this.userLayoutService.userData(resp);
        console.log(resp)
        this.language = this.userLayoutService.langData(resp);
        this.lang = this.userLayoutService.userLang(resp)
        console.log("======= Lang ========")
        console.log(this.lang)
        this.apiResponse = result.profile_image
        this.userName = result.username;
        this.lastLogin = result.last_login;
        this.profileImage = this.sanitizer.bypassSecurityTrustUrl(result.profile_image);
        localStorage.setItem('timezone', result.timezone);
        localStorage.setItem('userProfile', result.profile_image);

      }

    });

  }

  getLogo() {
    return "url('"+AppSettings.LOGO+"')";
  }

  logout() {
    this.authService.logout();
  }

}
